import type { DispatchUserMessageArgs } from "@/hooks/prompt-dispatch-types";
import type { InputDestinationKey } from "@/lib/input-destination-key";

/** Stable identity for a user-visible submission, excluding one-shot routing.
 *  Keyed by destination, never by the viewed project, so a retry after a
 *  view switch is the same request. */
export function buildPromptDispatchRetryKey(
  args: DispatchUserMessageArgs,
  destinationKey: InputDestinationKey,
): string {
  return JSON.stringify({
    destinationKey,
    composerId: args.composerId,
    text: args.text,
    explicitAgentKey: args.agentKey,
    imageIds: args.imageIds ?? [],
    awaitingInputId: args.awaitingInputId,
    mentionedAgents: args.mentionedAgents ?? [],
    mentionedFrames: args.mentionedFrames ?? [],
    promptSource: args.promptSource,
    conversationFrameId: args.conversationFrameId,
    forcedExecId: args.execId,
    forcedConversationId: args.conversationId,
    forcedRuntimeSessionId: args.runtimeSessionId,
    voiceAttention: args.voiceAttention,
    screenRecordings: args.screenRecordings,
  });
}
